export const isInterestSensitiveWholeLifePolicy = (policy) => {
  return policy?.product?.type?.toUpperCase().startsWith("LVS");
};
